'use strict'

var Geolocation = navigator.geolocation

window.Geolocation = Geolocation

export default Geolocation
